<template>
    <div class="header__nav-login">
        <div class="header__nav-loginBox">
            <v-btn class="btn-login" @click.prevent.stop="openLoginDialog">{{ $t('front.header.button.login') }}</v-btn>
            <v-btn class="btn-register" @click="openRegistrationDialog">{{ $t('front.header.button.register') }}</v-btn>

            <v-dialog scrollable content-class="dialog-login" max-width="472px"
                      v-model="$store.state.signIn.loginDialog"
                      :persistent="isDialogPersistent"
                      v-if="$store.state.signIn.loginDialog">
                <login @openRegister='openRegistrationDialog' @openForgot='openForgotDialog'/>
            </v-dialog>

            <v-dialog scrollable content-class="dialog-register" max-width="900px"
                      v-model="$store.state.signIn.registrationDialog"
                      :persistent="isDialogPersistent"
                      v-if="$store.state.signIn.registrationDialog">
                <register @openLogin='openLoginDialog'/>
            </v-dialog>

            <v-dialog scrollable content-class="dialog-forgot" max-width="472px"
                      v-model="$store.state.signIn.forgotPasswordDialog"
                      :persistent="isDialogPersistent"
                      v-if="$store.state.signIn.forgotPasswordDialog">
                <forgot-password @openLogin='openLoginDialog'/>
            </v-dialog>
        </div>
    </div>
</template>

<script>
import DialogSettings from '../../mixins/dialogSettings';

export default {
    name: "SignIn",

    mixins: [DialogSettings],

    methods: {
        openLoginDialog() {
            this.$store.commit('CLOSE_REGISTRATION_DIALOG');
            this.$store.commit('CLOSE_FORGOT_PASSWORD_DIALOG');
            this.$store.commit('OPEN_LOGIN_DIALOG');
        },

        openRegistrationDialog() {
            this.$store.commit('CLOSE_LOGIN_DIALOG');
            this.$store.commit('CLOSE_FORGOT_PASSWORD_DIALOG');
            this.$store.commit('OPEN_REGISTRATION_DIALOG');
        },

        openForgotDialog() {
            this.$store.commit('CLOSE_LOGIN_DIALOG');
            this.$store.commit('CLOSE_REGISTRATION_DIALOG');
            this.$store.commit('OPEN_FORGOT_PASSWORD_DIALOG');
        },
    }
}
</script>

<style lang="sass">
@import "sass/components/signIn/SignIn"
</style>